import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import ContactListsAPI from '../../api/contactLists';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getContactLists(_state) {
    return _state.records.sort((a, b) => a.name.localeCompare(b.name));
  },
  getContactListById: _state => id => {
    return _state.records.find(record => record.id === Number(id));
  },
};

export const actions = {
  get: async function getContactLists({ commit }) {
    commit(types.SET_CONTACT_LIST_UI_FLAG, { isFetching: true });
    try {
      const response = await ContactListsAPI.get();
      commit(types.SET_CONTACT_LISTS, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_CONTACT_LIST_UI_FLAG, { isFetching: false });
    }
  },

  show: async function showContactList({ commit }, id) {
    commit(types.SET_CONTACT_LIST_UI_FLAG, { isFetching: true });
    try {
      const response = await ContactListsAPI.show(id);
      commit(types.EDIT_CONTACT_LIST, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CONTACT_LIST_UI_FLAG, { isFetching: false });
    }
  },

  create: async function createContactList({ commit }, listObj) {
    commit(types.SET_CONTACT_LIST_UI_FLAG, { isCreating: true });
    try {
      const response = await ContactListsAPI.create(listObj);
      commit(types.ADD_CONTACT_LIST, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CONTACT_LIST_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_CONTACT_LIST_UI_FLAG, { isUpdating: true });
    try {
      const response = await ContactListsAPI.update(id, updateObj);
      commit(types.EDIT_CONTACT_LIST, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CONTACT_LIST_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async ({ commit }, id) => {
    commit(types.SET_CONTACT_LIST_UI_FLAG, { isDeleting: true });
    try {
      await ContactListsAPI.delete(id);
      commit(types.DELETE_CONTACT_LIST, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CONTACT_LIST_UI_FLAG, { isDeleting: false });
    }
  },

  addContacts: async (_, { listId, contactIds }) => {
    try {
      const response = await ContactListsAPI.addContacts(listId, contactIds);
      return response.data;
    } catch (error) {
      throw new Error(error);
    }
  },

  removeContacts: async (_, { listId, contactIds }) => {
    try {
      const response = await ContactListsAPI.removeContacts(listId, contactIds);
      return response.data;
    } catch (error) {
      throw new Error(error);
    }
  },

  getContacts: async (_, { listId, page }) => {
    try {
      const response = await ContactListsAPI.getContacts(listId, page);
      return response.data;
    } catch (error) {
      throw new Error(error);
    }
  },
};

export const mutations = {
  [types.SET_CONTACT_LIST_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.ADD_CONTACT_LIST]: MutationHelpers.create,
  [types.SET_CONTACT_LISTS]: MutationHelpers.set,
  [types.EDIT_CONTACT_LIST]: MutationHelpers.update,
  [types.DELETE_CONTACT_LIST]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
